import { useShallow } from 'zustand/react/shallow';
import { useAuth } from './auth';

export const useAddress = () => useAuth(useShallow((state) => state.address));
